module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "200px"
    }
  }, [_c('h1', [_vm._v("Edit Entry")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelled at:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.app.isLoading,
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "clearable": false
    },
    model: {
      value: (_vm.local.refueled_at),
      callback: function($$v) {
        _vm.local.refueled_at = $$v
      },
      expression: "local.refueled_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelling Amount (KG):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in KGs",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.refuelling_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.refuelling_amount),
      callback: function($$v) {
        _vm.local.refuelling_amount = $$v
      },
      expression: "local.refuelling_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.refuelling_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.refuelling_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), (_vm.app.user.vehicle_model === 'Symbio') ? _c('el-form-item', {
    attrs: {
      "label": "Electricity Amount (kWh):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in kWh",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.electricity_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.electricity_amount),
      callback: function($$v) {
        _vm.local.electricity_amount = $$v
      },
      expression: "local.electricity_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.electricity_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.electricity_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Odometer Reading (' + _vm.app.user.units + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Please enter your odometer reading in ' + _vm.app.user.units,
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.odometer_reading.$touch()
      }
    },
    model: {
      value: (_vm.local.odometer_reading),
      callback: function($$v) {
        _vm.local.odometer_reading = $$v
      },
      expression: "local.odometer_reading"
    }
  }), _vm._v(" "), (_vm.$v.local.odometer_reading.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.odometer_reading.numeric) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.odometer_reading.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Price (' + _vm.app.loadCurrencySymbol(_vm.app.user.currency) + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Optional: Please enter a price in ' + _vm.app.loadCurrencySymbol(_vm.app.user.currency),
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.price.$touch()
      }
    },
    model: {
      value: (_vm.local.price),
      callback: function($$v) {
        _vm.local.price = $$v
      },
      expression: "local.price"
    }
  }), _vm._v(" "), (_vm.$v.local.price.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.price.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.price.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Station Location: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter the refuelling location",
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.local.refuelling_station_location),
      callback: function($$v) {
        _vm.local.refuelling_station_location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.refuelling_station_location "
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Notes: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter any additional notes about this refuel",
      "type": "textarea",
      "autosize": ""
    },
    model: {
      value: (_vm.local.notes),
      callback: function($$v) {
        _vm.local.notes = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.notes "
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": _vm.updateEntry
    }
  }, [_vm._v("Update Entry")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.showConfirmDelete
    }
  }, [_vm._v("Delete Entry")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702b3538","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edit.vue
// module id = 634
// module chunks = 1